var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayText)?_c('b-badge',{staticClass:"text-capitalize",attrs:{"variant":_vm.statusVariant}},[_vm._v(" "+_vm._s(_vm.displayText)+" ")]):_c('span',{staticClass:"text-muted"},[_vm._v("-")])}
var staticRenderFns = []

export { render, staticRenderFns }